import _ from 'lodash'
import moment from 'moment'

export const fromFirebaseDate = (date) => {
  if (date) {
    return date.toDate()
  } else {
    return null
  }
}

export const yearMonth = (date) => {
  if (!date) return
  return new Date(date.getFullYear(), date.getMonth(), 2)
}

const MONTH_NAMES_CODE = {
  'Jan': '01',
  'Feb': '02',
  'Mar': '03',
  'Apr': '04',
  'May': '05',
  'Jun': '06',
  'Jul': '07',
  'Aug': '08',
  'Sep': '09',
  'Oct': '10',
  'Nov': '11',
  'Dec': '12'
}

export const parseInCurrentTimezone = (dateString) => {
  // eslint-disable-next-line
  return new Date(dateString.trim() + 'T00:00:00')
}

export const monthName = (date = new Date()) => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]

  return monthNames[date.getMonth()]
}

export const datesDiff = (a, b) => {
  const mls = 1000 * 60 * 60 * 24
  return Math.round((a - b) / mls)
}

export const minutes = (minutes) => {
  return minutes * 60 * 1000
}

export const currentPeriod = () => {
  const today = new Date()
  return new Date(today.getFullYear(), today.getMonth(), 2)
}

export const midnightToday = (date = new Date()) => {
  if (!date) return null

  const ensuredDate = new Date(date)
  ensuredDate.setHours(0, 0, 0, 0)
  return ensuredDate
}

export const midnight = (date = new Date()) => midnightToday(date)

export const endOfMonth = (date = midnight()) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

export const endOfNextMonth = (date = midnight()) => {
  return new Date(date.getFullYear(), date.getMonth() + 2, 0)
}

export const isCurrentMonth = (date, today = midnight()) => {
  return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth()
}

export const isNextMonth = (date, today = midnight()) => {

  if (today.getMonth() === 12) {
    return date.getFullYear() === today.getFullYear() + 1 && date.getMonth() === 0
  } else {
    return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() + 1
  }
}

export const presentPeriod = () => {
  const today = new Date()
  return new Date(today.getFullYear(), today.getMonth(), 2)
}

export const lastPeriod = () => {
  const today = new Date()
  return new Date(today.getFullYear(), today.getMonth() - 1, 2)
}

export const nextPeriod = () => {
  const today = new Date()

  if (today.getMonth() === 12) {
    return new Date(today.getFullYear() + 1, 1, 2)
  } else {
    return new Date(today.getFullYear(), today.getMonth() + 1, 2)
  }
}

export const formatyyymmdd = (date) => {
  const stringDate = String(date)

  const day = stringDate.slice(8, 10).trim()
  const month = MONTH_NAMES_CODE[stringDate.slice(4, 7).trim()]
  const year = stringDate.slice(11, 15)

  return `${year}-${month}-${day}`
}

export const periodRelativeToCurrent = (current, monthDiff) => {
  return new Date(current.getFullYear(), current.getMonth() + monthDiff, 2)
}

export const periodRelativeTo = (current, monthDiff) => {
  return periodRelativeToCurrent(current, monthDiff)
}

export const nextPeriodFromDate = (today) => {
  if (today.getMonth() === 12) {
    return new Date(today.getFullYear() + 1, 1, 2)
  } else {
    return new Date(today.getFullYear(), today.getMonth() + 1, 2)
  }
}

export const isCurrentPeriod = (period) => {
  return _.isEqual(
    yearMonth(period),
    yearMonth(currentPeriod())
  )
}

export const isPresentPeriod = (period) => {
  return _.isEqual(
    yearMonth(period),
    yearMonth(currentPeriod())
  )
}

export const isPastPeriod = (period) => {
  const today = new Date()

  return period.getFullYear() < today.getFullYear() ||
  (period.getFullYear() === today.getFullYear() && period.getMonth() < today.getMonth())

}

export const isPast = (date) => {
  const today = midnight()

  return date < today
}

export const isFuture = (date) => {
  if (!date) return
  const today = midnight()

  return date > today
}

export const addDays = (date, days) => {
  const original = new Date(date)
  original.setDate(original.getDate() + days)
  return original
}

// export const daysAgoCount = (days) => {
//   addDays(midnight(), -days)
// }

export const daysAgo = (days) => {
  return addDays(midnight(), -days)
}

export const daysFromDate = (date = new Date()) => {
  const now = new Date()
  const diffTime = Math.abs(ensureDate(date) - now)
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}

export const countDaysAgo = (date = new Date()) => {
  const now = new Date()
  const diffTime = now - ensureDate(date)
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}

export const isFriday = (date = new Date()) => {
  return date.getDay() == 5
}

export const firstThreeDayOfWeek = (date = new Date()) => {
  return date.getDay() >= 1 && date.getDay() <= 3
}

export const getNextMonday = (date = new Date()) => {
  return midnight(addDays(date, 8 - date.getDay()))
}

export const daysSinceDate = (date = new Date()) => {
  return datesDiff(midnight(), date)
}

export const isYoungerThan = (date, days) => {
  return daysSinceDate(midnight(date)) < days
}

export const ensureDate = (d) => {
  return d.toDate ?  d.toDate() : d
}

export const ensuredDateEqual = (date1, date2) => {
  if (!date1 || !date2) return false
  return ensureDate(date1).getTime() === ensureDate(date2).getTime()
}

export const areEqual = (date1, date2) => {
  return date1.getTime() === date2.getTime()
}

export const dateIn = (date, date1, date2) => {
  return date >= date1.getTime() && date <= date2.getTime()
}

export const startOfWeek = (date) => {
  return moment(date).startOf('isoWeek')
}

export const thisWeek = () => {
  const from = midnight(startOfWeek(new Date()))

  return { from, to: midnight(moment(from).endOf('isoWeek'))}
}

export const lastWeek = () => {
  const from = midnight(startOfWeek(addDays(new Date(), -7)))

  return { from, to: midnight(moment(from).endOf('isoWeek'))}
}

export const thisMonth = () => {
  const date = new Date(), y = date.getFullYear(), m = date.getMonth()
  const from = new Date(y, m, 1)
  const to = new Date(y, m + 1, 0)

  return { from, to}
}

export const lastMonth = () => {
  const date = new Date(), y = date.getFullYear(), m = date.getMonth()
  const from = new Date(y, m - 1, 1)
  const to = new Date(y, m, 0)

  return { from, to}
}

export const midnightTomorrowFromToday = (date) => {
  date = new Date(date)

  date.setDate(date.getDate() + 1)
  return midnight(date)
}

export const isMetadate = (date) => {
  return date === 'soon' || date === 'someday' || !date
}

export const isSunday = (date) => {
  return midnight(date).getDay() === 0
}

export const isMonday = (date) => {
  return midnight(date).getDay() === 1
}

export const midnightTomorrow = () => {
  const date = new Date()
  date.setDate(date.getDate() + 1)
  return midnight(date)
}

export const midnightYesterday = () => {
  const date = new Date()
  date.setDate(date.getDate() - 1)
  return midnight(date)
}

export const monthYearFormat = (date) => {
  return date.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })
}

export const monthFormat = (date) => {
  return date.toLocaleDateString('en-GB', { month: 'long' })
}

export const arePeriodsEqual = (period1, period2) => {
  return _.isEqual(yearMonth(period1), yearMonth(period2))
}

export const monthInWordsFormat = (date) => {
  if (date === null) {
    return 'Not Planned'
  }

  if (isCurrentPeriod(date)) {
    return 'Current Month'
  } else if (isCurrentPeriod(periodRelativeToCurrent(date, -1))) {
    return 'Next Month'
  } else if (isCurrentPeriod(periodRelativeToCurrent(date, 1))) {
    return 'Last Month'
  }

  return monthYearFormat(date)
}

export const isToday = (date) => {
  return areEqual(midnightToday(), date)
}

export const daysFromNow = (x) => {
  return addDays(midnight(), x)
}

export const oneMonthFromNow = (date = midnight()) => {
  return addDays(date, 30)
}

export const periodWord = (from, to) => {
  if (!isPast(to)) {
    return 'this week'
  } else if (datesDiff(midnight(), to) < 6) {
    return 'last week'
  } else {
    // eslint-disable-next-line
    return from.toLocaleDateString('en-GB', { month: 'short', day: 'numeric' }) +
    ' - ' +
    to.toLocaleDateString('en-GB', { month: 'short', day: 'numeric' })

  }
}

export const getDateObject = (obj) => {
  if (!obj) { return obj }

  if (Object.prototype.toString.call(obj) === '[object String]') {
    return parseInCurrentTimezone(obj.trim())
  } else {
    return ensureDate(obj)
  }
}
